<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import PhoneInput from "@/components/common/PhoneInput.vue";
import { store } from "@/store";

export default {
    name: "AppPersonalInfo",
    components: { GlobalHeader, PhoneInput },
    data: () => ({
        store,
        name: null,
    }),
    methods: {
        handleSubmit() {
            if(!this.name || this.name.length < 2) {
                this.$alert.danger({ message: '방문자명을 2자 이상 입력해주세요.' });
                return;
            }
            store.visitor.name = this.name;
            this.$router.replace({ path: `/schools/${store.school.id}/visit/apply` });

        }
    },
    mounted() {
        this.name = store.visitor.name;
    }
};
</script>

<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :title="'학교 방문예약'"
            />
            <div class="content">
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            방문자명
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-input class="h48" v-model="name"/>
                    </div>
                </div>
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            전화번호
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <phone-input v-model="store.visitor.phone" disabled/>
                    </div>
                </div>
                <div class="submit-btn">
                    <button @click="handleSubmit">신청 시작하기</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>